import { CommonModule, DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output, signal, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ClarityModule, ClrDatagrid, ClrForm } from '@clr/angular';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import SignaturePad from 'signature_pad';
import { BackendLocaleDatePipe } from 'src/app/pipes/get-locale-date.pipe';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { APIService } from 'src/app/services/APIService/api.service';
import { AuthService } from 'src/app/services/Auth/auth.service';
import { HilfeBeschreibungModalComponent } from '../../_modals/hilfebeschreibungmodal/hilfebeschreibungmodal.component';
import { PreviewThumbnailsComponent } from '../../_shared/preview-thumbnails/preview-thumbnails.component';
import { HideIDColumnsPipe } from 'src/app/pipes/hide-idcolumns.pipe';
import { ConfirmService } from 'src/app/services/confirm.service';

export interface FormulareRow {
  ID: number;
  Typ: string;
  FeldName: string;
  AuswahlOption: string;
  Bezeichnung: string;
}

@Component({
  selector: 'app-fatpruefungsdialog',
  templateUrl: './fatpruefungsdialog.component.html',
  styleUrls: ['./fatpruefungsdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    FormsModule,
    ReactiveFormsModule,
    PreviewThumbnailsComponent,
    HilfeBeschreibungModalComponent,
    MrTranslatePipe,
    HideIDColumnsPipe,
    BackendLocaleDatePipe,
  ],
})
export class FatpruefungsdialogComponent implements OnInit {
  private apiservice = inject(APIService);
  private toastr = inject(ToastrService);
  private mrTranslate = inject(MrTranslatePipe);
  private datePipe = inject(DatePipe);
  private _sanitizer = inject(DomSanitizer);
  private authService = inject(AuthService);
  protected localeDate = inject(BackendLocaleDatePipe);
  private confirmService = inject(ConfirmService);

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);

  dataRefresh = new EventEmitter();
  set data(dataIn: any) {
    this.ostammid = dataIn.id;

    if (dataIn.lpid != undefined) {
      this.opruefid = dataIn.lpid;
    }

    this.getFatFieldsValueByID();

    this.dataRefresh = dataIn.dataRefresh;
  }

  objekteGroup = new UntypedFormGroup({
    objektName: new UntypedFormControl('', [Validators.required]),
    vorlageName: new UntypedFormControl('', [Validators.required]),
    //data: null
  });

  visualGroup = new UntypedFormGroup({
    objektName: new UntypedFormControl('', [Validators.required]),
    vorlageName: new UntypedFormControl('', [Validators.required]),
    //data: null
  });

  selectedmessrow: any;
  locked: boolean = true;
  ostammid: number = 0;
  opruefid: number = 0;

  //clrtab: any[] = [];
  clrtab: {
    titel: string | null;
    zindex: number | 0;
    openstate: boolean | false;
    items: any[] | [];
  }[] = [];

  //tabellen2: any;
  //tabellen3: any;
  //tabellen4: any;
  //combinedDataPage2: any[] = [];
  //combinedDataPage3: any[] = [];
  //combinedDataPage4: any[] = [];
  showsignaturpad: boolean = false;
  modaltitel: string;
  signaturtype: any;

  resultForm = new UntypedFormGroup({
    datum: new UntypedFormControl(BackendLocaleDatePipe.now),
    pruefername: new UntypedFormControl(''),
    ort: new UntypedFormControl(''),
    kundename: new UntypedFormControl(''),
    pruefersignatur: new UntypedFormControl(''),
    kundesignatur: new UntypedFormControl(''),
    bemerkung: new UntypedFormControl(''),
  });

  sig: SignaturePad;
  structures: any;
  formulare: any;
  formulareOriginal: any;
  tabellen: any;
  tabellenOriginal: any;
  spezifikationsdaten = { columns: [], mapping: {} };
  auswahlOptions = ['Stammdaten', 'Spezifikationsdaten', 'Herstellerdaten'];
  firstColumnId = 'Typ';
  secondColumnId = 'FeldName';
  selected: any = [];
  previewThumbnails: any[] = [];
  previewMessThumbnails: any[] = [];

  kundesignatur: any[] = [];
  pruefersignatur: any[] = [];

  showBildModal: boolean = false;
  bildData: any;
  username: string = '';
  vorlageid: number;

  formReflectData: {
    table: string | null;
    fieldname: string | null;
    fieldType: string | null;
    fieldLength: string | null;
    subheading: string | null;
    value: string | null;
    title: string | null;
    mainTitle: string | null;
  }[] = [];

  vorlagename: string = 'Vorlage';

  skizzen: any;
  curSkizzen: any = [];
  bemerkungmessung: string = '';

  opruef: any;
  omess: any;
  messbilder: any;

  @ViewChild(ClrDatagrid) grid: ClrDatagrid;
  @ViewChild(ClrForm) form: ClrForm;
  @ViewChild('canvas', { static: true }) canvas: ElementRef;
  @Output() modalOpen = new EventEmitter<boolean>();

  @ViewChild('mainPreview', { static: false })
  mainPreview: PreviewThumbnailsComponent;
  @ViewChild('messPreview', { static: false })
  messPreview: PreviewThumbnailsComponent;

  protected readonly isHelperModalOpen = signal(false);
  protected readonly openedHelperId = signal<number>(null);

  public showWebcam = true;

  triggerLock() {
    this.locked = !this.locked;
  }

  selectionmMessrowChanged(value: any) {
    if (value.bilder && this.messPreview) {
      this.messPreview.rawPreviewThumbnails = [...value.bilder];
    } else if (this.messPreview) {
      this.messPreview.clearPreview();
    }
  }

  _currentPage: number = 1;
  set currentPage(newPage: number) {
    this._currentPage = newPage;
  }
  get currentPage() {
    return this._currentPage;
  }

  set _modalOpen(newVal: boolean) {
    this.modalOpen.emit(newVal);
  }

  // loading: boolean = true;

  activeTab: any = {
    formulare: false,
    tabellen: false,
  };

  isVorlageAddVisible: boolean = false;
  @ViewChild('_vorlage_new') _vorlage_new: ElementRef;
  @ViewChild('_zaehlercode') _zaehlercode: ElementRef;
  @ViewChild('_zaehlerbezeichnung') _zaehlerbezeichnung: ElementRef;

  bemrow: any;
  openModalBem: boolean = false;
  @ViewChild('rowBem') rowBem: ElementRef;

  openBem(row: any) {
    this.bemrow = row;
    if (this.bemrow.bemerkung) this.rowBem.nativeElement.value = this.bemrow.bemerkung;
    else this.rowBem.nativeElement.value = '';
    this.openModalBem = true;
  }
  setBem() {
    this.selectedmessrow = this.bemrow;
    this.selectedmessrow.bemerkung = this.rowBem.nativeElement.value;
    this.rowBem.nativeElement.value = '';
    this.openModalBem = false;
  }

  /**
   * @method Selects a row for photo capture and switches to the measurement preview component
   * This method bridges the old camera modal pattern to the new preview-thumbnails component
   */
  selectRowForPhoto(row: any) {
    this.selectedmessrow = row;
    // Load existing photos from row if available
    if (row.bilder && Array.isArray(row.bilder)) {
      this.messPreview.rawPreviewThumbnails = [...row.bilder];
    } else {
      this.messPreview.clearPreview();
    }
    // User can now use the messPreview component to add/manage photos
    // Photos will be synced back when validation runs or save occurs
  }

  /** @deprecated Legacy method - replaced by selectRowForPhoto */
  openCamera(typ: any) {
    this.selectRowForPhoto(typ);
  }

  getFatFieldsValueByID() {
    this.apiservice
      .getFatFieldValueByID(this.ostammid, this.opruefid)
      .pipe(first())
      .subscribe((result: any) => {
        this.omess = [];
        this.opruef = [];
        this.messbilder = [];

        const spezColumns =
          Array.isArray(result?.spezifikationsdaten?.columns) ? result.spezifikationsdaten.columns : [];
        const spezMapping = result?.spezifikationsdaten?.mapping || {};

        this.spezifikationsdaten.columns = spezColumns.map(col => {
          return {
            display: col,
            value: Object.keys(spezMapping).find(key => spezMapping[key] === col),
          };
        });
        this.spezifikationsdaten.mapping = spezMapping;

        const structuresRows = Array.isArray(result?.structures?.rows) ? result.structures.rows : [];
        const vorlageRows = Array.isArray(result?.vorlage?.rows) ? result.vorlage.rows : [];
        const groupnamesRows = Array.isArray(result?.groupnames?.rows) ? result.groupnames.rows : [];
        const tabellennamenRows = Array.isArray(result?.tabellennamen?.rows) ? result.tabellennamen.rows : [];
        const tabellenRows = Array.isArray(result?.tabellen?.rows) ? result.tabellen.rows : [];
        const tabellenColumns = Array.isArray(result?.tabellen?.columns) ? result.tabellen.columns : [];

        this.structures = structuresRows;
        this.vorlageid = result.vorlageid;
        this.formulare = {
          ...(result?.vorlage || {}),
          rows: vorlageRows,
        };

        this.vorlagename = result.vorlagename;
        this.skizzen = result?.skizzen && typeof result.skizzen === 'object' ? result.skizzen : {};

        // this.formulare.rows.forEach(row => {
        //   if (row.AuswahlOption === 'Spezifikationsdaten') {
        //     row.Bezeichnung = this.spezifikationsdaten.mapping[row.Bezeichnung] || row.Bezeichnung;
        //   }
        // });
        this.formulareOriginal = JSON.parse(JSON.stringify(vorlageRows));

        this.formReflectData = this.formulare.rows.map((row: FormulareRow) => {
          const reflectData = {
            table: row['Tabelle'],
            fieldname: row['Bezeichnung'],
            subheading: null,
            fieldType: row['Bezeichnung'],
            fieldLength: null,
            value: null,
          };
          this.updateFormReflectData(row, reflectData);
          return reflectData;
        });

        this.formReflectData.forEach(data => {
          // ? Nirgendwo benutzt
          // this.objekteGroup.addControl(
          //   data.fieldname,
          //   new UntypedFormControl(data, Validators.maxLength(3))
          // );
          switch (data.table) {
            case 'Stammdaten':
              data.value = result?.ostamm?.[data.fieldname as any] ?? null;
              break;
            case 'Spezifikationsdaten':
              data.value = result?.ospez?.[data.fieldname as any] ?? null;
              break;
            case 'Herstellerdaten':
              data.value = result?.oherst?.[data.fieldname as any] ?? null;
              break;
          }
        });

        const opruefRows = Array.isArray(result?.opruef?.rows) ? result.opruef.rows : [];
        if (opruefRows.length > 0) {
          this.opruef = opruefRows;
          this.opruef[0].P_MUser;
          this.resultForm.controls.pruefername.setValue(this.opruef[0].P_MUser);
          this.resultForm.controls.datum.setValue(this.opruef[0].P_MDatum);
          this.resultForm.controls.ort.setValue(this.opruef[0].P_KeinePrfGrund);
          this.resultForm.controls.kundename.setValue(this.opruef[0].P_Kunde);
          this.resultForm.controls.bemerkung.setValue(this.opruef[0].P_Bemerkung);
          let sigP = this.opruef[0].P_Pruefer_U;
          let sigK = this.opruef[0].P_Kunde_U;
          //pruefersignatur
          //kundesignatur
        }

        if (Array.isArray(result?.omess?.rows)) {
          this.omess = result.omess.rows;
        }

        if (Array.isArray(result?.bilder?.rows)) {
          this.messbilder = result.bilder.rows;

          this.previewThumbnails = [];

          let bilderL = this.messbilder.filter(element => element.typ == 0);
          bilderL.forEach(bild => {
            this.previewThumbnails.push({
              src: this._sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + bild.base64),
              file: { name: bild.bildname, type: 'image/png' },
              date: this.datePipe.transform(bild.datum, 'dd.MM.yyyy HH.mm.ss.SSS'),
              base64: bild.base64,
              extension: 'png',
              saved: true,
            });
          });

          // Sync with mainPreview component after load
          setTimeout(() => {
            if (this.mainPreview) {
              this.mainPreview.rawPreviewThumbnails = [...this.previewThumbnails];
            }
          });
        }

        // DEBUG: High-level payload overview
        try {
          console.log('[FAT Prüfen][DEBUG] getFatFieldValueByID payload overview', {
            ostammid: this.ostammid,
            opruefid: this.opruefid,
            hasGroupnames: !!result.groupnames,
            hasTabellennamen: !!result.tabellennamen,
            hasTabellen: !!result.tabellen,
            groupnamesCount: result?.groupnames?.rows?.length ?? -1,
            tabellennamenCount: result?.tabellennamen?.rows?.length ?? -1,
            tabellenRowsCount: result?.tabellen?.rows?.length ?? -1,
          });
        } catch {}

        const hasExecutionData = groupnamesRows.length > 0 && tabellennamenRows.length > 0 && tabellenRows.length > 0;

        if (!hasExecutionData) {
          this.clrtab = [];
          this.tabellenOriginal = [];
          this.toastr.error(
            this.mrTranslate.transform(
              'Für dieses Objekt sind keine FAT-Prüfdaten vorhanden. Eine Werksabnahme kann nicht durchgeführt werden.'
            )
          );
          try {
            console.warn('[FAT Prüfen][WARN] Missing FAT execution data', {
              ostammid: this.ostammid,
              groupnamesCount: groupnamesRows.length,
              tabellennamenCount: tabellennamenRows.length,
              tabellenRowsCount: tabellenRows.length,
            });
          } catch {}
          return;
        }

        let groupnames = groupnamesRows;

        // ✅ DEDUPLICATE: remove duplicate group names by Code to prevent duplicate tabs
        const seenCodes = new Set<string>();
        const dedupedGroupnames: any[] = [];
        for (const group of groupnames || []) {
          const code = (group.Code || '').toString().trim();
          if (!code) continue; // skip empty codes
          if (seenCodes.has(code.toLowerCase())) continue; // already added (case-insensitive)
          seenCodes.add(code.toLowerCase());
          dedupedGroupnames.push(group);
        }
        if (dedupedGroupnames.length !== groupnames.length) {
          console.log(
            `🔧 [FAT-Prüfung] Deduplicated group tabs: original=${groupnames.length} unique=${dedupedGroupnames.length}`
          );
        }
        groupnames = dedupedGroupnames;

        // ✅ Sort tabs alphanumerically by Code (stable)
        if (Array.isArray(groupnames)) {
          const collatorTabs: Intl.Collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base',
          });
          groupnames.sort((a: any, b: any) => collatorTabs.compare(a?.Code ?? '', b?.Code ?? ''));
        }

        let tabellennamen = tabellennamenRows;
        let zindex: number = 0;

        for (let tabs of groupnames) {
          let tabelle = tabellennamen.filter(element => element.Code == tabs.Code);
          let combinedDataPage: any[] = [];
          let openstate = false;

          // Sort tables within each tab by their display title, then by Code for tie-breaks
          if (Array.isArray(tabelle)) {
            const collatorItems: Intl.Collator = new Intl.Collator(undefined, {
              numeric: true,
              sensitivity: 'base',
            });
            tabelle.sort(
              (a: any, b: any) =>
                collatorItems.compare(a?.Bezeichnung ?? '', b?.Bezeichnung ?? '') ||
                collatorItems.compare(a?.Code ?? '', b?.Code ?? '')
            );
          }

          for (let table of tabelle) {
            const filteredRows = tabellenRows.filter(x => x.SZAEHNID == table.ID);

            // DEBUG: Per-table diagnostics
            try {
              console.log('[FAT Prüfen][DEBUG] table build', {
                code: tabs.Code,
                szaehnid: table.ID,
                title: table.Bezeichnung,
                sourceType: table.SourceType,
                filteredRows: filteredRows.length,
              });
            } catch {}

            let tb = {
              columns: tabellenColumns,
              rows: filteredRows,
            };

            if (this.omess.length != 0) {
              let rowmess = this.omess.filter(x => x.SZAEHNID == table.ID);
              // DEBUG: Existing measurement merges by SZAEHNID
              try {
                console.log('[FAT Prüfen][DEBUG] omess merge', {
                  szaehnid: table.ID,
                  omessCount: rowmess.length,
                });
              } catch {}
              rowmess.forEach(rowElement => {
                const code = rowElement.Bezeichnung;

                for (let i = 0; i < tb.rows.length; i++) {
                  let row = tb.rows[i];
                  if (rowElement.Bezeichnung == row.Code) {
                    row.istValue = rowElement.Ist != 'non' ? rowElement.Ist : undefined;
                    row.ausfallValue = rowElement.Ausfall != '' ? rowElement.Ausfall : undefined;
                    row.bemerkung = rowElement.Bemerkung != '' ? rowElement.Bemerkung : undefined;

                    this.previewMessThumbnails = [];

                    let bilderL = this.messbilder.filter(element => element.id == rowElement.ID);
                    bilderL.forEach(bild => {
                      this.previewMessThumbnails.push({
                        src: this._sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + bild.base64),
                        file: { name: bild.bildname, type: 'image/png' },
                        date: this.datePipe.transform(bild.datum, 'dd.MM.yyyy HH.mm.ss.SSS'),
                        base64: bild.base64,
                        extension: 'png',
                        saved: true,
                      });
                    });

                    row.bilder = this.previewMessThumbnails.length != 0 ? this.previewMessThumbnails : undefined;
                    break;
                  }
                }
              });
            }

            this.curSkizzen = [];
            Object.keys(this.skizzen).forEach(typid => {
              if (typid == table.ID.toString()) {
                this.curSkizzen = this.skizzen[typid];
              }
            });

            let items = {
              szaehnid: table.ID,
              iscompleted: false,
              hasfaults: false,
              title: table.Bezeichnung,
              tableData: tb,
              SourceType: table.SourceType,
              images: this.curSkizzen,
              hasHelper: table.HasHelper,
              bemerkung: table.Bemerkung,
            };

            // Recompute completion/faults after merging prior measurements/images
            this.checkCompletedFaults(items);

            combinedDataPage.push(items);

            if (table.SourceType == 1) {
              openstate = true;
              tb.rows.map(elem => {
                this.visualGroup.addControl(elem.Code, new UntypedFormControl(elem, Validators.maxLength(3)));
              });
            }
          }

          const clrtab = {
            titel: tabs.Code,
            zindex: zindex,
            openstate: openstate,
            items: combinedDataPage,
          };

          // DEBUG: Tab summary
          try {
            console.log('[FAT Prüfen][DEBUG] tab summary', {
              titel: clrtab.titel,
              items: clrtab.items?.length ?? 0,
              openstate: clrtab.openstate,
            });
          } catch {}

          this.clrtab.push(clrtab);

          zindex++;
        }
        // Normalize previously saved visual values (ok/bad) to radio values ("0"/"1")
        this.normalizeVisuellValuesForUI();
        // VISUEL DEBUG: summarize what we received for visual rows
        try {
          const visSummary = [] as any[];
          for (const tab of this.clrtab) {
            for (const item of tab.items) {
              if (item?.SourceType === 1) {
                const rows = item?.tableData?.rows || [];
                visSummary.push({
                  code: tab.titel,
                  szaehnid: item.szaehnid,
                  title: item.title,
                  count: rows.length,
                  istValues: rows.map((r: any) => r.istValue),
                });
              }
            }
          }
          if (visSummary.length) console.log('[FAT Prüfen][VISUEL DEBUG] loaded visual rows', visSummary);
        } catch {}
        /*
        this.tabellen2 = tabellennamen.rows.filter(element => element.Code == 'AIGUILLAGE');
        for(let tab of this.tabellen2){

          let tb={
            columns: result.tabellen.columns,
            rows: result.tabellen.rows.filter(x => x.SZAEHNID == tab.ID)
          }
          let items ={
            szaehnid: tab.ID,
            iscompleted: false,
            hasfaults: false,
            title: tab.Bezeichnung,
            tableData: tb,
            image: tab.Bild64 ? this._sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + tab.Bild64) : null,
          }
          this.combinedDataPage2.push(items);
        }

        this.tabellen3 = tabellennamen.rows.filter(element => element.Code == 'INTERMEDIATE');
        for(let tab of this.tabellen3){

          let tb={
            columns: result.tabellen.columns,
            rows: result.tabellen.rows.filter(x => x.SZAEHNID == tab.ID)
          }
          let items ={
            szaehnid: tab.ID,
            iscompleted: false,
            hasfaults: false,
            title: tab.Bezeichnung,
            tableData: tb,
            image: tab.Bild64
          }
          this.combinedDataPage3.push(items);
        }

        this.tabellen4 = tabellennamen.rows.filter(element => element.Code == 'VISUEL');
        for(let tab of this.tabellen4){

          let tb={
            szaehnid: tab.ID,
            iscompleted: false,
            hasfaults: false,
            columns: result.tabellen.columns,
            rows: result.tabellen.rows.filter(x => x.SZAEHNID == tab.ID)
          }
          this.combinedDataPage4.push(tb);
        }

        this.combinedDataPage4[0].rows.map((elem) => {
          this.visualGroup.addControl(elem.Code, new UntypedFormControl(elem,Validators.maxLength(3)));
        });
        */
        this.tabellenOriginal = tabellenRows;
      });
  }

  // Map legacy visual values to current UI radio values to keep selection persistent
  private normalizeVisuellValuesForUI(): void {
    try {
      // Accept multiple representations from backend: 'OK'/'ok', localized words, 0/1, booleans
      const okSynonyms = new Set<string>([
        'ok',
        'o.k.',
        'accepted',
        'accepté',
        'akzeptiert',
        'accettato',
        'aceptado',
        'goed',
        'bon',
        'bueno',
        'gut',
        'ja',
        'yes',
        'true',
        'pass',
      ]);
      const badSynonyms = new Set<string>([
        'bad',
        'not accepted',
        'non accepté',
        'nicht akzeptiert',
        'non accettato',
        'rechazado',
        'slecht',
        'mauvais',
        'malo',
        'schlecht',
        'nein',
        'no',
        'false',
        'fail',
      ]);

      for (const tab of this.clrtab || []) {
        for (const item of tab.items || []) {
          if (item?.SourceType !== 1) continue; // visual only
          const rows = item?.tableData?.rows || [];
          for (const row of rows) {
            let v = row?.istValue;
            if (v === undefined || v === null) continue;

            // Coerce numbers/booleans first
            if (typeof v === 'number') {
              row.istValue =
                v === 0 ? '0'
                : v === 1 ? '1'
                : row.istValue;
              continue;
            }
            if (typeof v === 'boolean') {
              row.istValue = v ? '1' : '0';
              continue;
            }

            // Strings: trim and case-fold
            if (typeof v === 'string') {
              const s = v.trim();
              if (s === '0' || s === '1') {
                row.istValue = s; // already normalized
                continue;
              }
              const lower = s.toLowerCase();
              if (okSynonyms.has(lower)) {
                row.istValue = '0';
                continue;
              }
              if (badSynonyms.has(lower)) {
                row.istValue = '1';
                continue;
              }
              // Legacy exacts
              if (lower === 'ok') row.istValue = '0';
              else if (lower === 'bad') row.istValue = '1';
            }
          }
        }
      }
    } catch {}
  }

  panelChange(event, tabelle) {
    if (event) {
      // tabelle.iscompleted = true;
      // tabelle.hasfaults = true;
      // this.tabellen.rows =  this.tabellenOriginal.filter(x => x.SZAEHNID == tabelle.ID);
      this.checkCompletedFaults(tabelle);
      console.log('panel is opening');
    }
  }

  checkCompletedFaults(tabelle: any) {
    let hasFaults = false;
    let incomplete = false;

    const rows = tabelle?.tableData?.rows ?? [];
    for (const row of rows) {
      // Fault state: explicit SR0 means fault
      if (row?.ausfallValue === 'SR0') {
        hasFaults = true;
      }

      const soll = row?.Soll;
      const tolMinus = row?.['Tol -'] ?? row?.['tol -'] ?? row?.['tol-'];
      const tolPlus = row?.['Tol +'] ?? row?.['tol +'] ?? row?.['tol+'];
      const ist = row?.istValue;

      // Determine measurement type (numeric vs visual/boolean)
      const hasNumericSoll = typeof soll === 'number' || (!isNaN(parseFloat(soll)) && isFinite(parseFloat(soll)));

      if (hasNumericSoll) {
        const n = parseFloat(ist);
        if (isNaN(n)) {
          incomplete = true;
        } else {
          const baseSoll = parseFloat(soll);
          const tmin = typeof tolMinus === 'number' ? tolMinus : parseFloat(tolMinus);
          const tmax = typeof tolPlus === 'number' ? tolPlus : parseFloat(tolPlus);
          const minAllowed = isNaN(tmin) ? baseSoll : baseSoll - tmin;
          const maxAllowed = isNaN(tmax) ? baseSoll : baseSoll + tmax;
          if (n < minAllowed || n > maxAllowed) {
            hasFaults = true;
          }
        }
      } else {
        // Visual/boolean style rows: consider 'ok' or 'bad' as explicitly set
        if (ist === undefined || ist === null || ist === '') {
          incomplete = true;
        } else if (typeof ist === 'string') {
          const norm = ist.toLowerCase();
          if (norm !== 'ok' && norm !== 'bad') {
            // Not a recognized categorical value; still counts as filled
          }
        }
      }
    }

    tabelle.hasfaults = hasFaults;
    tabelle.iscompleted = !incomplete;
  }

  updatesignatur() {
    let signaturpng = this.sig.toDataURL();
    if (this.signaturtype == 'pruefer') {
      let r = signaturpng.toString() as String;
      var splitted = r.split(',');

      this.pruefersignatur.push({
        src: this._sanitizer.bypassSecurityTrustUrl(signaturpng),
        file: '',
        date: this.datePipe.transform(Date.now(), 'dd.MM.yyyy HH.mm.ss.SSS'),
        base64: splitted[1],
      });
    } else {
      let r = signaturpng.toString() as String;
      var splitted = r.split(',');

      this.kundesignatur.push({
        src: this._sanitizer.bypassSecurityTrustUrl(signaturpng),
        file: '',
        date: this.datePipe.transform(Date.now(), 'dd.MM.yyyy HH.mm.ss.SSS'),
        base64: splitted[1],
      });
    }
    this.showsignaturpad = true;
  }

  addSignatur(value: any) {
    this.sig = new SignaturePad(this.canvas.nativeElement);
    this.signaturtype = value;
    this.modaltitel = 'Unterschrift';
    this.showsignaturpad = true;
  }

  deletesignatur() {
    this.sig.clear();
  }

  handleChange(val: number, row: any, tabelle: any) {
    if (row.bilder != undefined) this.previewMessThumbnails = row.bilder;
    else this.previewMessThumbnails = [];

    tabelle.hasfaults = false;
    tabelle.iscompleted = false;

    row.ausfallValue = val == 0 ? null : 'SR0';

    this.checkCompletedFaults(tabelle);
  }

  /**
   * @method Called when a photo is added to a visual inspection row
   * @param cell The visual inspection row that received a photo
   * @param tabelle The parent table/item to revalidate
   */
  handleVisualRowPhotoAdded(cell: any, tabelle: any) {
    // Photos are automatically managed by the preview-thumbnails component
    // We just need to revalidate the completion status
    this.checkCompletedFaults(tabelle);
  }

  submitDemo(typ: any) {}
  showPreviewSkizze(image: any) {
    this.bildData = image;
    this.showBildModal = true;
  }

  showPreviewImage(image: any) {
    this.bildData = image.src;
    this.showBildModal = true;
  }

  tabChange() {
    this.selected = [];
    this.currentPage = 1;
    this.previewMessThumbnails = [];
  }

  validateRow(row: any, tabelle: any) {
    tabelle.hasfaults = false;
    tabelle.iscompleted = false;

    if (!row.istValue || isNaN(row.istValue)) {
      row.ausfallValue = null;
      tabelle.iscompleted = false;
      return;
    }

    const ist = parseFloat(row.istValue);

    let tmin = 1000000;
    let tmax = 1000000;

    if (row['Tol -'] != undefined) tmin = row['Tol -'];

    if (row['Tol +'] != undefined) tmax = row['Tol +'];

    const maxAllowed = row.Soll + tmax;
    const minAllowed = row.Soll - tmin;

    if (ist < minAllowed || ist > maxAllowed) {
      row.ausfallValue = 'SR0';
    } else {
      row.ausfallValue = null;
    }

    this.checkCompletedFaults(tabelle);
  }

  updateFormReflectData(row: any, reflectData: any) {
    if (row[this.firstColumnId] === 'Überschrift') {
      reflectData.mainTitle = null;
      reflectData.title = row['FeldName'];
      reflectData.subheading = null;
    } else if (row[this.firstColumnId] === 'Normales Feld') {
      reflectData.mainTitle = null;
      reflectData.title = null;
      reflectData.subheading = row['FeldName'];
    } else if (row[this.firstColumnId] === 'Titel') {
      reflectData.mainTitle = row['FeldName'];
      reflectData.title = null;
      reflectData.subheading = null;
    }
    let columnName = row['Bezeichnung'];

    if (columnName != null && this.structures) {
      let stable = 'ostamm';

      if (row['Tabelle'] === 'Spezifikationsdaten') stable = 'ospez';

      if (row['Tabelle'] === 'Herstellerdaten') stable = 'oherst';

      const rowToDelete = this.structures.find(
        (row: any) => row.TABLE_NAME === stable && row.COLUMN_NAME === columnName
      );

      if (rowToDelete != undefined) {
        let formFieldType;
        switch (rowToDelete.DATA_TYPE.toUpperCase()) {
          case 'VARCHAR':
          case 'TEXT':
            formFieldType = 'text';
            break;
          case 'DATETIME':
            formFieldType = 'date';
            break;
          case 'DECIMAL':
          case 'INT':
          case 'FLOAT':
            formFieldType = 'dropdown';
            break;
          case 'BIT':
            formFieldType = 'checkbox';
            break;
        }
        reflectData.fieldType = formFieldType;
      }
    }
  }

  async sendForFormulare() {
    let allcompleted = true;
    for (let tab of this.clrtab) {
      for (let item of tab.items) {
        if (item.iscompleted == false) {
          allcompleted = false;
          break;
        }
      }
    }

    /*
    for (let item of this.clrtab.items){
      if (item.iscompleted == false){
        allcompleted = false;
        break;
      }
    }
    if (allcompleted == true){
      for (let items of this.combinedDataPage3){
        if (items.iscompleted == false){
          allcompleted = false;
          break;
        }
      }
    }
    if (allcompleted == true){
      for (let items of this.combinedDataPage4){
        for (let row of items.rows){
          if (!row.istValue || isNaN(row.istValue)){
            allcompleted = false;
            break;
          }
        }
      }
    }
*/

    if (allcompleted == false) {
      const ok = await this.confirmService.danger(
        this.mrTranslate.transform('Die Messungen sind unvollständig, möchten Sie sie trotzdem speichern?')
      );
      if (!ok) {
        return;
      }
    }

    let allmessrows: any[] = [];

    /*
      for (let item of this.combinedDataPage2){
        for (let row of item.tableData.rows){
          allmessrows.push(row);
        }
      }

      for (let item of this.combinedDataPage3){
        for (let row of item.tableData.rows){
          allmessrows.push(row);
        }
      }

      for (let item of this.combinedDataPage4){
        for (let row of item.rows){
          allmessrows.push(row);
        }
      }
    */

    for (let tab of this.clrtab) {
      for (let item of tab.items) {
        for (let row of item.tableData.rows) {
          allmessrows.push(row);
        }
      }
    }

    // VISUEL DEBUG: what we are about to send
    try {
      const outVis = [] as any[];
      for (const tab of this.clrtab) {
        for (const item of tab.items) {
          if (item?.SourceType === 1) {
            const rows = item?.tableData?.rows || [];
            outVis.push({
              code: tab.titel,
              szaehnid: item.szaehnid,
              title: item.title,
              istValues: rows.map((r: any) => r.istValue),
            });
          }
        }
      }
      if (outVis.length) console.log('[FAT Prüfen][VISUEL DEBUG] outgoing visual rows', outVis);
    } catch {}

    // Collect photos from mainPreview component
    let pbild: any[] = [];
    if (this.mainPreview) {
      const mainPhotos = this.mainPreview.rawPreviewThumbnails.filter(t => !t.saved);
      for (let bi of mainPhotos) {
        let bild = {
          date: bi.date,
          base64: bi.base64,
        };
        pbild.push(bild);
      }
    } else {
      // Fallback to legacy array if component not initialized
      for (let bi of this.previewThumbnails) {
        let bild = {
          date: bi.date,
          base64: bi.base64,
        };
        pbild.push(bild);
      }
    }

    // Sync measurement row photos from messPreview component back to rows
    if (this.messPreview && this.selectedmessrow) {
      this.selectedmessrow.bilder = this.messPreview.rawPreviewThumbnails;
    }

    let vals = this.resultForm.value;

    if (this.pruefersignatur.length > 0) {
      let jArray = this.pruefersignatur.map(o => o.base64);
      vals.pruefersignatur = JSON.parse(JSON.stringify(jArray));
    } else vals.pruefersignatur = '';

    if (this.kundesignatur.length > 0) {
      let jArray = this.kundesignatur.map(o => o.base64);
      vals.kundesignatur = JSON.parse(JSON.stringify(jArray));
    } else vals.kundesignatur = '';

    let info = {
      pdatum: vals.datum,
      pname: vals.pruefername,
      port: vals.ort,
      pkname: vals.kundename,
      pbem: vals.bemerkung,
      punter: vals.pruefersignatur,
      pkunter: vals.kundesignatur,
    };

    this.apiservice
      .addPruefungFAT(this.formReflectData, allmessrows, pbild, info, this.ostammid, this.opruefid, this.vorlageid)
      .pipe(first())
      .subscribe(val => {
        this.opruefid = parseInt(val.toString());
        if (this.opruefid > 1) {
          this.toastr.success(this.mrTranslate.transform('Daten gespeichert'));
          this.dataRefresh.emit();
          // Notify host views (e.g., Anlagen) to reload lists
          try {
            window.dispatchEvent(new CustomEvent('mrpro:fat-updated'));
          } catch {}
        }
      });
  }

  ngOnInit() {
    this.username = this.authService.getToken().username;
    this.resultForm.controls.pruefername.setValue(this.username);
  }

  public close() {
    this.closedialog.next(true);
  }
}
